import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'

import { PromoEmailsWrapper } from '../../components'

export default function PromoEmailsPage() {
  return (
    <ModalProvider>
      <PromoEmailsWrapper />
    </ModalProvider>
  )
}
